<template>
	<div class="Sonance_Case">
		<vue-headful
				description=""
				title="Slumberland | Sonance Audition"
		/>
		<CaseTop
				cover="Sonance_cover.jpg"
				subTitle="Design 360° <br/>Mission : conseil, création de la marque, déclinaison des supports, accompagnement"
				title="Sonance Audition"
		/>
		<ContentList
				id="mission"
				:columns=1
				alignText="center"
				title="Mission"
		>
			Sonance Audition, réseau d’audioprothésistes indépendants, nous a confié en 2014, la création de son identité
			visuelle et de son territoire de marque, avec pour ambition : un positionnement premium, un engagement de qualité,
			un cadre valorisant l’esthétique contemporaine et centré sur l’accueil du patient.
		</ContentList>
		<ImageSingle
				image="Sonance_007.jpg"
				parallax="true"
		>
		</ImageSingle>
		<ContentList
				id="identite"
				:columns=1
				alignText="center"
				bgColor="#f6f6f6"
				title="Identité"
		>
			Le design de marque élégant et pur, tranche avec le marché concurrent. Le symbole est un repère puissant. Il donne
			du sens au parcours sonore. Il crée un lien intuitif avec l’univers de style émotionnel iconographique. Le ton
			rédactionnel, affirmé et singulier, marque les esprits.
		</ContentList>
		<ImageSingle
				animated="false"
				boxed="true"
				image="Sonance_001.svg"
				style="padding-top:0;padding-bottom:0"
		>
		</ImageSingle>
		<ImageSingle
				image="Sonance_002.png"
				parallax="true"
		>
		</ImageSingle>
		<ContentList
				id="signaletique"
				:columns=1
				alignText="center"
				title="Signalétique"
		>
			Un principe signalétique efficace et modulable pour chaque espace architectural des laboratoires.
		</ContentList>
		<ImageList
				:columns=2
				:imagelistItems="[{ image: 'Sonance_003.jpg'},{ image: 'Sonance_004.jpg'},{ image: 'Sonance_005.jpg'},{ image: 'Sonance_006.jpg'}]"
		>
		</ImageList>
		<ContentList
				id="edition"
				:columns=1
				alignText="center"
				title="Édition"
		>
			Une diversité d’outils d’éditions, d’affiches pédagogiques et ludiques pour accompagner le patient, clarifier le
			discours du praticien et valoriser son métier.
		</ContentList>
		<ImageSingle
				bgColor="#f6f6f6"
				image="Sonance_008.jpg"
				parallax="true"
		>
		</ImageSingle>
		<ContentList
				id="site"
				:columns=1
				alignText="center"
				title="Site internet"
		>
			Création du site internet pédagogique qui présente l’esprit Sonance Audition.
		</ContentList>

		<Carousel
				:carouselImages="[{ image: 'Sonance_009.jpg'},{ image: 'Sonance_010.jpg'},{ image: 'Sonance_013.jpg'},{ image: 'Sonance_014.jpg'}]"
				bgColor="#f6f6f6"
				boxed="true"
				mask="desktop"
		/>
		<ContentList
				id="packaging"
				:columns=1
				alignText="center"
				title="Packaging"
		>
			Une gamme de soins spécifique, déclinée avec les ingrédients de la charte graphique, renforce l’harmonie
			esthétique globale des espace des laboratoire Sonance Audition.
		</ContentList>
		<ImageSingle
				boxed="true"
				center="true"
				image="Sonance_011.jpg"
		>
		</ImageSingle>
		<ContentList
				id="resultat"
				:columns=1
				alignText="center"
				bgColor="#f6f6f6"
				title="Résultat"
		>
			Depuis Janvier 2020, plus de 90 centres Sonance Audition ont été ouverts en 5 ans sur le territoire français.
		</ContentList>
		<CaseNext
				page="Création affiches"
		>
		</CaseNext>
	</div>


</template>

<script>

import CaseTop from "@/components/CaseTop.vue";
import CaseNext from "@/components/CaseNext.vue";
import ContentList from "@/components/ContentList.vue";
import ImageSingle from "@/components/ImageSingle.vue";
import ImageList from "@/components/ImageList.vue";
import Carousel from "@/components/Carousel.vue";

export default {
	name: "CaseSonance",
	components: {
		CaseTop, ContentList, ImageSingle, CaseNext, ImageList, Carousel
	},
	data() {
		return {};
	},
	methods: {
		imgPath: function (image) {
			return require("../assets/images/" + image);
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@use '@/assets/scss/partials/variables' as *;
@use '@/assets/scss/partials/mixins' as *;


</style>
